// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5346":"9dee5396c04341f2","5608":"dc5b566259538648","6329":"e59ea02bc211f25b","6366":"f18a62bea7901d99","9268":"afacb330c93c2aa1"}[chunkId] + ".js";
};